<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加价格控制配置</el-button
    >

    <el-dialog
      title="添加价格控制配置"
      width="600px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="当前价格" prop="spotPrice">
          <el-input
            type="number"
            v-model="ruleForm.spotPrice"
         
          ></el-input>
        </el-form-item> -->
        <el-form-item label="目标价格" prop="targetPrice">
          <el-input
            type="number"
            v-model="ruleForm.targetPrice"
            placeholder="请输入目标价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="数量倍数" prop="amount">
          <el-input
            type="number"
            v-model="ruleForm.amount"
            placeholder="请输入目标价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="交易对" prop="pair" required>
          <!-- <el-input
            v-model="ruleForm.pair"
            placeholder="请选择开始时间"
          ></el-input> -->
          <el-select v-model="ruleForm.pair" clearable placeholder="请选择">
            <el-option
              v-for="item in pairList"
              :key="item.id"
              :label="item.symbol"
              :value="item.symbol">
            </el-option>
          </el-select>
        </el-form-item>
       <!--  <el-form-item label="结束时间" prop="endTime">
          <el-input
            v-model="ruleForm.endTime"
            placeholder="请选择结束时间"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="开始-结束时间" >
          <!-- <el-input
            v-model="ruleForm.endTime"
            placeholder="请选择结束时间"
          ></el-input> -->
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {ValidateCode,ValidateEN,ValidateLocale,ValidateZH,ValidateLineUrl } from '../../validate.js'

export default {
  data() {
    
    return {
      dialogVisible: false,
      value2: [],
      ruleForm: {

      },
      arr: [],
      result: false,
      rules: {
        targetPrice: [
          {
            required: true,
            message: "请填写目标价格",
            trigger: "blur",
          },
        ],
        spotPrice: [
          {
            required: true,
            message: "请填写当前价格",
            trigger: "blur",
          },
        ],
       
      
      },
      pickerOptions: {
        shortcuts: [
        {
            text: "未来两分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 200 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来五分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 500 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来十分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 1000 );
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来半小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 600 * 1000 *3);
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "未来一小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000);
              picker.$emit("pick", [start, end]);
            },
          },
        {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    // this.ruleForm = {
    //   zh: "",
    //   lineUrl:'',
    //   en: "",
    //   status: 0,
    // };
    this.getPairList()
  },
  computed:{
    ...mapState('priceControl',['pairList'])
  },
  methods: {
    ...mapActions("priceControl", ["addOne", "getlist","getUrlList",'getPairList']),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    closeDialog() {},
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
     submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if(valid){
      const obj={...this.ruleForm,targetPrice:Number(this.ruleForm.targetPrice),amount:Number(this.ruleForm.amount)}
        // this.$refs[formName].validate(async (val) => {
         const res=await this.addOne(obj)
         if(res.code==0){
           this.dialogVisible = false;
           this.getUrlList({page:1,size:10,pair:''})
           this.resetForm(formName)
            this.$message.success("添加成功");
         }else{
        this.$message.console.error("添加失败，请重试");
         }
        }
      })

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
